import { memo } from 'react';
import FilterSlideoutSection from '../FilterSlideoutSection.jsx';
import { FILTER_SLIDEOUT_INLINE_ERROR } from '../filterSlideoutTokens.js';
import { clearSection, getSectionActiveCount, hasInvalidNumericRange } from '../filterSlideout.utils.js';

function RangeInput({ label, value, placeholder, onChange, disabled }) {
  return (
    <div className="relative min-w-0 flex-1 pt-[6px]">
      <input
        type="number"
        className="h-8 w-full rounded-lg border-[0.5px] border-[#5C5C5C] bg-white px-4 text-sm font-medium leading-5 text-content outline-none placeholder:text-content-faint hover:border-accent/50 focus:border-accent/50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-edge dark:bg-surface"
        value={value ?? ''}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      />
      {label ? (
        <span className="pointer-events-none absolute left-4 top-0 bg-white px-1 text-[11px] font-semibold leading-none text-content dark:bg-surface dark:text-white">
          {label}
        </span>
      ) : null}
    </div>
  );
}

const NumericRangeSection = ({ section }) => {
  const activeCount = getSectionActiveCount(section);
  const value = section.value ?? {};
  const invalid = hasInvalidNumericRange(section);

  const handleChange = (key, next) => {
    section.onChange?.({ ...value, [key]: next });
  };

  return (
    <FilterSlideoutSection
      title={section.title}
      defaultExpanded={section.defaultExpanded ?? true}
      disabled={section.disabled}
      activeCount={activeCount}
      onClear={() => clearSection(section)}
    >
      <div className="flex flex-col gap-2">
        <div className="flex gap-3">
          <RangeInput
            label={section.minLabel}
            value={value.min}
            placeholder={section.minPlaceholder ?? '0'}
            onChange={(e) => handleChange('min', e.target.value)}
            disabled={section.disabled}
          />
          <RangeInput
            label={section.maxLabel}
            value={value.max}
            placeholder={section.maxPlaceholder ?? '∞'}
            onChange={(e) => handleChange('max', e.target.value)}
            disabled={section.disabled}
          />
        </div>
        {invalid ? (
          <p className={FILTER_SLIDEOUT_INLINE_ERROR}>
            Min must be less than or equal to max.
          </p>
        ) : null}
      </div>
    </FilterSlideoutSection>
  );
};

export default memo(NumericRangeSection);
